import { parseDateTime } from './delivery'

export const parseRideCreationPayload = (payload) => {
  const dateTime = parseDateTime(payload.start.date, payload.start.time)
  return {
    ...payload,
    start: { address: payload.start.address, googlePlaceId: payload.start.googlePlaceId, fromDatetime: dateTime },
  }
}
